// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import Header from 'components/Header';
import Footer from 'components/Footer';

const StockViewLayout = ({ children }) => {

	return (
		<div className='CustomerLayout'>
			
			<Header/>

			<Container>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

StockViewLayout.propTypes = {
	children: PropTypes.node,
}

StockViewLayout.defaultProps = {
	children: null,
}

export default StockViewLayout